export default __webpack_public_path__ + "static/media/IT.014c9a9f.jpg";